﻿import {SupplierSortByHookTypes} from "../../types/SupplierSortByHookTypes";
import {useEffect} from "react";
import _ from "underscore";
import {Supplier} from "../../types/Supplier";

const useSupplierSortByMonthlyRateHigh = ({ searchSortBy, unsortedSuppliers, sortedSuppliersSetter }: SupplierSortByHookTypes) => {
  useEffect(() => {
    if (searchSortBy === 'monthly-rate-high' && unsortedSuppliers.length) {
      sortedSuppliersSetter(_.sortBy(unsortedSuppliers, (supplier: Supplier) => supplier?.pricePerMonth || -Infinity).reverse());
    }
  }, [searchSortBy, sortedSuppliersSetter, unsortedSuppliers]);
}

export { useSupplierSortByMonthlyRateHigh };
